import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  EmailSettingGetEmailSetting,
  EmailSettingSetEmailSetting,
} from "../../Api/Services";
import { toast } from "react-toastify";

function EmailSetting() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const start = async () => {
    try {
      const EmailSettingGetEmailSettingData =
        await EmailSettingGetEmailSetting();
      if (
        EmailSettingGetEmailSettingData.status &&
        EmailSettingGetEmailSettingData.status === 200
      ) {
        setForm(EmailSettingGetEmailSettingData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.mail === "") {
      toast.error("ایمیل را وارد نمایید ");
      validation = false;
    }
    if (form.displayName === "") {
      toast.error("Display Name را وارد نمایید ");
      validation = false;
    }
    if (form.host === "") {
      toast.error("Host  را وارد نمایید ");
      validation = false;
    }
    if (form.password === "") {
      toast.error("Password  را وارد نمایید ");
      validation = false;
    }
    if (form.port === "") {
      toast.error("Port  را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        const EmailSettingSetEmailSettingData =
          await EmailSettingSetEmailSetting(form);
        if (
          EmailSettingSetEmailSettingData.status &&
          EmailSettingSetEmailSettingData.status === 200
        ) {
          toast.success("بروزرسانی با موفقیت انجام شد");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="mail"
                id="mail"
                text="mail"
                className="m-2"
                value={form.mail || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="displayName"
                id="displayName"
                className="m-2"
                text="Display Name"
                value={form.displayName || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="password"
                id="password"
                className="m-2"
                text="Password"
                value={form.password || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="host"
                id="host"
                className="m-2"
                text="Host"
                value={form.host || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="port"
                id="port"
                className="m-2"
                text="Port"
                value={form.port || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {"ثبت"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailSetting;
